/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Site_Agent_ProfileInputs */

const cs_public_site_agent_profile = /** @type {(inputs: Public_Site_Agent_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil makléře`)
};

const en_public_site_agent_profile = /** @type {(inputs: Public_Site_Agent_ProfileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent profile`)
};

/**
* | output |
* | --- |
* | "Agent profile" |
*
* @param {Public_Site_Agent_ProfileInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const public_site_agent_profile = /** @type {((inputs?: Public_Site_Agent_ProfileInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Site_Agent_ProfileInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_public_site_agent_profile(inputs)
	return cs_public_site_agent_profile(inputs)
});